<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" :form="form" @keyup.enter="handleSearch">
        <a-row :gutter="48">
          <a-col :md="5" :sm="8">
            <a-form-item >
              <a-input placeholder="角色名称/角色描述" @keyup.enter="handleSearch" v-decorator="[ 'query']"/>
            </a-form-item>
          </a-col>
          
          <a-col :md="6" :sm="8">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleSearch">查询</a-button>
               &nbsp; &nbsp;  &nbsp; &nbsp; 
              <a-button type="danger" @click="handleAdd">添加</a-button>
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>

    <s-table
      size="middle"
      :columns="columns"
      :data="loadData"
      @add_role_ok="reloadData"
      ref="datatable"
      :showPagination=true
    >
     
      <span slot="action" slot-scope="text, record">
        <a-tag size="small" color="green" @click="handleEdit(record)">编辑</a-tag>
        <a-tag size="small" color="blue" @click="handlePermit(record)">授权</a-tag>
        <a-tag size="small" color="red" @click="handleDelete(record)">删除</a-tag>
      </span>

    </s-table>

    <edit-role-modal ref="editRoleModal" @dataChanged="reloadData" />

    <add-role-modal @ok="reloadData" ref="addRoleModal"/>

    <add-role-permission-modal ref="addRolePermissionModal" @authorize_ok="reloadData"/>
  </a-card>
</template>

<script>
import STable from '@/components/table/'
import SelectProjectUser from '@/components/selector/SelectProjectUser'
import SelectHospital from '@/components/selector/SelectHospital'
import SelectTime from '@/components/selector/SelectTime'
import SelectLabelStatus from '@/components/selector/SelectLabelStatus'
import DispatchDataModal from './modules/DispatchDataModal'
import ArrangeMemberListModal from './modules/ArrangeMemberListModal'
import EditDataModal from './modules/EditDataModal'
import EditUserModal from './modules/EditUserModal'
import EditRoleModal from './modules/EditRoleModal'
import AddRoleModal  from './modules/AddRoleModal'
import AddRolePermissionModal from './modules/AddRolePermissionModal'

import { axios } from '@/utils/request'
import { getAssignDataList, deleteTaskData, getUserStatisticsList } from '@/api/data'
import { getUserList, updateUserInfo, createUser, deleteUser, resetPwd } from '@/api/adminuser'
import { 
     getRoleList, updateRole , createRole , deleteRole , getRolePer ,grantRolePer
     } 
     from '@/api/adminrole'
import { getLabelStatusText, getHospitalText, getUserStatusToText } from '@/utils/const'
import { alias } from 'ant-design-vue/es/icon/utils';
export default {
  name: 'AdimRoleList',
  components: {
    STable,
    SelectProjectUser,
    SelectHospital,
    SelectTime,
    SelectLabelStatus,
    DispatchDataModal,
    ArrangeMemberListModal,
    EditDataModal,
    EditUserModal,
    EditRoleModal,
    AddRoleModal,
    AddRolePermissionModal,
  },
  data () {
    return {
      description: '列表使用场景：后台管理中的权限管理以及角色管理，可用于基于 RBAC 设计的角色权限控制，颗粒度细到每一个操作类型。',
      visible: false,

      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      form: this.$form.createForm(this),
      mdl: {},

      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      conditions: {},
      columns: [
        {
          title: '编号',
          dataIndex: 'id',
          key: 'id'
        },
        {
          title: '角色名称',
          dataIndex: 'name',
          key: 'name'
        },
        {
          title: '角色描述',
          dataIndex: 'des',
          key: 'des'
        },
        {
          title: '角色权限',
          dataIndex: 'permissions',
          key: 'permissions'
        },
        {
          title: '操作',
          width: 230,
          dataIndex: 'action',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象

      loadData: (page) => {
        const _this = this
        return new Promise(resolve => {
          return getRoleList(Object.assign({
            page_num: page.pageNo,
            page_size: page.pageSize
          }, _this.conditions)
          ).then(res => {
            if (res.data.length == 0) {
              _this.$refs.datatable.localLoading = false
              const params = {
                data: [],
                pageNo: 1,
                pageSize: 10,
                totalCount: 0
              }
              resolve(params)
              return
            }
            const datas = []
            var id = ((page.pageNo - 1) * page.pageSize | 0) + 1
            for (let item = res.data.shift(); item != null; item = res.data.shift()) {
              datas.push({
                id: id++,
                name: item.name,
                des: item.des,
                permissions: item.permissions ,
                origin_data: item
              })
            }
            const params = {
              data: datas,
              pageNo: page.pageNo,
              pageSize: page.pageSize,
              totalCount: res.total
            }
            resolve(params)
          }).catch(res => {
            _this.$refs.datatable.localLoading = false
          })
        })
      },
      selectedRowKeys: [],
      selectedRows: []
    }
  },

  methods: {

    handleDispatch (record) {
      this.$refs.dispatch.add(record.data_id)
    },
    handleArrange (record) {
      this.$refs.arrange.add(record.origin_data)
    },
    handleAdd () {
      this.$refs.addRoleModal.add()
    },
    handleEdit (record) {
      this.$refs.editRoleModal.edit(record)
    },
    handleDelete (record) {
      const _this = this
      this.$confirm({
        title: '删除操作确认',
        content: '是否确定删除用户角色名为“' + record.name + '”的用户角色？',
        width: '440px',
        onOk () {
          return new Promise((resolve, reject) => {
            deleteRole(record.origin_data.id).then(res => {
              if (res.code != 200)_this.$message.error(res.msg)
              _this.$message.success(res.msg)
              resolve()
            }).catch(() => {
              _this.$message.error('删除失败')
              reject()
            }).finally(() => {
              _this.reloadData()
            }
            )
          })
        },
        onCancel () {}
      })
    },

    handlePermit (record) {
      debugger
      this.$refs.addRolePermissionModal.edit(record.origin_data)
      this.visible = true
    },

    onChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },

    reloadData () {
      debugger
      this.dataHandle = this.loadData
      this.$refs.datatable.refresh()
    },

    handleSearch () {
      const conditions = this.conditions = {}
      this.form.validateFields((err, values) => {
        if (values.query) conditions.query = values.query
      })
      this.reloadData()
    }
  },
  watch: {
    /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
  }
}
</script>
